import React, { useState } from 'react';
import { FaSearch, FaPlus, FaEllipsisV } from 'react-icons/fa';
import './styles/SwitchProject.css';
import projectIcon from './icons/project_icon.svg';

function SwitchProject() {
  const [activeTab, setActiveTab] = useState('Cities');
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState('grid');
  const [sortBy, setSortBy] = useState('Last Modified');

  // Sample project data
  const projects = [
    {
      id: 1,
      name: 'Location Name',
      description: 'Sample description that includes details of project type, category, roadway type, traffic data, pollutants, and more.',
      dateRange: '(01/01/01) - (12/31/01)',
      lastModified: '2 weeks ago',
      budget: 'Budget'
    },
    {
      id: 2,
      name: 'Location Name',
      description: 'Sample description that includes details of project type, category, roadway type, traffic data, pollutants, and more.',
      dateRange: '(01/01/01) - (12/31/01)',
      lastModified: '2 weeks ago',
      budget: 'Budget'
    },
    {
      id: 3,
      name: 'Location Name',
      description: 'Sample description that includes details of project type, category, roadway type, traffic data, pollutants, and more.',
      dateRange: '(01/01/01) - (12/31/01)',
      lastModified: '2 weeks ago',
      budget: 'Budget'
    },
    {
      id: 4,
      name: 'Location Name',
      description: 'Sample description that includes details of project type, category, roadway type, traffic data, pollutants, and more.',
      dateRange: '(01/01/01) - (12/31/01)',
      lastModified: '2 weeks ago',
      budget: 'Budget'
    },
    {
      id: 5,
      name: 'Location Name',
      description: 'Sample description that includes details of project type, category, roadway type, traffic data, pollutants, and more.',
      dateRange: '(01/01/01) - (12/31/01)',
      lastModified: '2 weeks ago',
      budget: 'Budget'
    },
    {
      id: 6,
      name: 'Location Name',
      description: 'Sample description that includes details of project type, category, roadway type, traffic data, pollutants, and more.',
      dateRange: '(01/01/01) - (12/31/01)',
      lastModified: '2 weeks ago',
      budget: 'Budget'
    },
    {
      id: 7,
      name: 'Location Name',
      description: 'Sample description that includes details of project type, category, roadway type, traffic data, pollutants, and more.',
      dateRange: '(01/01/01) - (12/31/01)',
      lastModified: '2 weeks ago',
      budget: 'Budget'
    },
    {
      id: 8,
      name: 'Location Name',
      description: 'Sample description that includes details of project type, category, roadway type, traffic data, pollutants, and more.',
      dateRange: '(01/01/01) - (12/31/01)',
      lastModified: '2 weeks ago',
      budget: 'Budget'
    },
    {
      id: 9,
      name: 'Location Name',
      description: 'Sample description that includes details of project type, category, roadway type, traffic data, pollutants, and more.',
      dateRange: '(01/01/01) - (12/31/01)',
      lastModified: '2 weeks ago',
      budget: 'Budget'
    }
  ];

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSortChange = (e) => {
    setSortBy(e.target.value);
  };

  const handleViewModeChange = (mode) => {
    setViewMode(mode);
  };

  // Filter projects based on search
  const filteredProjects = projects.filter(project => 
    project.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    project.description.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="switch-project-container">
      <h1>Switch Project</h1>
      
      <div className="location-type-tabs">
        <button 
          className={activeTab === 'Counties' ? 'tab-active' : ''} 
          onClick={() => handleTabChange('Counties')}
        >
          Counties
        </button>
        <button 
          className={activeTab === 'States' ? 'tab-active' : ''} 
          onClick={() => handleTabChange('States')}
        >
          States
        </button>
        <button 
          className={activeTab === 'Cities' ? 'tab-active' : ''} 
          onClick={() => handleTabChange('Cities')}
        >
          Cities
        </button>
        <button 
          className={activeTab === 'Project-Specific Locations' ? 'tab-active' : ''} 
          onClick={() => handleTabChange('Project-Specific Locations')}
        >
          Project-Specific Locations
        </button>
      </div>
      
      <div className="projects-controls">
        <div className="search-container">
          <div className="search-input-wrapper">
            <FaSearch className="search-icon" size={16} color="#7CC644" />
            <input
              type="text"
              className="search-input"
              placeholder="Search"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
        </div>
        
        <div className="view-controls">
          <div className="view-toggle">
            <button 
              className={`grid-view-btn ${viewMode === 'grid' ? 'active' : ''}`}
              onClick={() => handleViewModeChange('grid')}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="7" height="7" rx="1" fill={viewMode === 'grid' ? '#7CC644' : '#666'} />
                <rect x="14" y="3" width="7" height="7" rx="1" fill={viewMode === 'grid' ? '#7CC644' : '#666'} />
                <rect x="3" y="14" width="7" height="7" rx="1" fill={viewMode === 'grid' ? '#7CC644' : '#666'} />
                <rect x="14" y="14" width="7" height="7" rx="1" fill={viewMode === 'grid' ? '#7CC644' : '#666'} />
              </svg>
            </button>
            <button 
              className={`list-view-btn ${viewMode === 'list' ? 'active' : ''}`}
              onClick={() => handleViewModeChange('list')}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="4" width="18" height="2" rx="1" fill={viewMode === 'list' ? '#7CC644' : '#666'} />
                <rect x="3" y="11" width="18" height="2" rx="1" fill={viewMode === 'list' ? '#7CC644' : '#666'} />
                <rect x="3" y="18" width="18" height="2" rx="1" fill={viewMode === 'list' ? '#7CC644' : '#666'} />
              </svg>
            </button>
          </div>
          
          <div className="sort-dropdown">
            <span>SORT BY:</span>
            <select value={sortBy} onChange={handleSortChange}>
              <option value="Last Modified">Last Modified</option>
              <option value="Name">Name</option>
              <option value="Date Created">Date Created</option>
            </select>
          </div>
          
          <button className="create-new-btn">
            Create new
          </button>
        </div>
      </div>
      
      <div className={`projects-grid ${viewMode === 'list' ? 'list-view' : ''}`}>
        {filteredProjects.map(project => (
          <div key={project.id} className="project-card">
            <div className="project-icon">
              <img src={projectIcon} alt="Project" />
            </div>
            
            <div className="project-header">
              <h3>{project.name}</h3>
              <button className="more-options-btn">
                <FaEllipsisV size={16} color="#ccc" />
              </button>
            </div>
            
            <div className="project-tags">
              <span className="budget-tag">{project.budget}</span>
              <span className="date-tag">{project.dateRange}</span>
            </div>
            
            <p className="project-description">{project.description}</p>
            
            <div className="project-meta">
              <p className="details-note">COULD PROBABLY MODIFY THIS SECTION INTO DIFFERENT UI FOR AFOREMENTIONED DETAILS.</p>
              <div className="last-modified">
                <span>Last Modified: {project.lastModified}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SwitchProject; 